// removed by extract-text-webpack-plugin
module.exports = {"consentText":"ConsentForm__consentText--3X9gC","content":"ConsentForm__content--4DhAL","actions":"ConsentForm__actions--MTykU","btnSubmit":"ConsentForm__btnSubmit--AGYUk","checkbox":"ConsentForm__checkbox--ygy35","check":"ConsentForm__check--2Wmwj"};


//////////////////
// WEBPACK FOOTER
// ./src/client/src/components/ConsentForm.scss
// module id = 335
// module chunks = 0